import { render } from "./tarifs_et_contrats.vue?vue&type=template&id=5a533937"
import script from "./tarifs_et_contrats.vue?vue&type=script&lang=js"
export * from "./tarifs_et_contrats.vue?vue&type=script&lang=js"

import "./tarifs_et_contrats.vue?vue&type=style&index=0&id=5a533937&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__